// @core/api/endpoints/chat/list_pinned_messages.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListPinnedMessagesResponse,
} from '../../../types/chat';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/chat';

/**
 * List pinned messages
 * Returns all pinned messages in the conversation, sorted by pin date. Includes full message content and pin metadata.
 */
export async function ListPinnedMessages(
  conversation_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListPinnedMessagesResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/conversations/:conversation_id/pins`;
  requestPath = requestPath.replace(':conversation_id', encodeURIComponent(conversation_id));
  const requestOptions = options;
  return client.get<ListPinnedMessagesResponse>(requestPath, { ...requestOptions, params });
}
